import React from 'react';
import { Grid } from 'semantic-ui-react';

const PageWidth = ({ width, children }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column {...width}>{children}</Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

PageWidth.defaultProps = {
  width: {
    largeScreen: 15,
    widescreen: 10,
    tablet: 16,
  },
};

export { PageWidth };



// WEBPACK FOOTER //
// ./src/components/layout/PageWidth.js